<template>
  <div class="list-table">
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-select
                no-data-text="Datos no disponibles"
                :items="laboratories"
                label="Laboratorio"
                v-model="laboratory"
                dense
                clearable
              ></v-select>
              <v-text-field
                clearable
                flat
                hide-details
                placeholder="Busqueda..."
                solo
                v-model="search"
              ></v-text-field>
              <v-btn icon>
                <v-icon @click="onSearch">search</v-icon>
              </v-btn>
              <v-btn @click="onDownload" icon color="success">
                <v-icon>cloud_download</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-toolbar card color="white">
              <v-spacer></v-spacer>
              <v-btn @click="handleUploadCSV()" color="success"
                >Subir CSV</v-btn
              >
              <v-btn @click="deleting.show = true" color="error"
                >Eliminar Productos</v-btn
              >
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="products"
                :loading="pagination.loading"
                :total-items="pagination.totalItems"
                hide-actions
                no-data-text="Datos no disponibles"
                no-results-text="No se encontraron registros coincidentes"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-left">{{ props.item.product.name }}</td>
                  <td class="text-sm-left">{{ props.item.fxFormula }}</td>
                  <td class="text-sm-left">{{ props.item.sanitaryReg }}</td>
                  <td class="text-sm-left">{{ props.item.batchNumber }}</td>
                  <td class="text-sm-left">
                    {{ dateFormat(props.item.expirationDate) }}
                  </td>
                  <td class="text-sm-left">
                    {{ props.item.total_certificate }}
                  </td>
                  <td class="text-sm-left">
                    <v-chip
                      :color="getColorByStatus(props.item.batchStatus)"
                      label
                      small
                      text-color="white"
                      >{{ getLabelByStatus(props.item.batchStatus) }}</v-chip
                    >
                  </td>
                  <td class="text-sm-left">
                    <v-btn
                      :to="`/productos/editar/${props.item.id}`"
                      color="info"
                      flat
                      icon
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <!--<v-btn
                      @click="deleteProduct(props.item.batchNumber)"
                      color="error"
                      flat
                      icon
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>-->
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div class="text-xs-center pt-2" v-if="pagination.pages">
            <v-pagination
              :length="pagination.pages"
              :total-visible="7"
              @input="asyncPagination"
              v-model="pagination.page"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog max-width="500" v-model="csv.show">
      <upload-csv
        :key="csv.key"
        v-on:close-csv="csv.show = false"
        v-on:loading-show="loading = true"
        v-on:upload-ready="uploadReady"
      ></upload-csv>
    </v-dialog>

    <v-dialog max-width="350" persistent v-model="loading">
      <loading></loading>
    </v-dialog>

    <v-dialog max-width="500" persistent v-model="deleting.show">
      <deleting
        :key="deleting.key"
        v-on:loading-show="loading = true"
        v-on:close="deleting.show = false"
        v-on:delete-ready="deleteReady"
      ></deleting>
    </v-dialog>

    <v-dialog max-width="600" persistent v-model="processing">
      <div class="text-center">
        <v-card color="info" dark>
          <v-card-text>
            El archivo a sido cargado en el sistema, procesando las columnas,
            sea paciente ...
            <v-progress-linear
              class="mb-0"
              color="white"
              indeterminate
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </div>
    </v-dialog>

    <v-dialog max-width="500" v-if="dialog.message" v-model="dialog.show">
      <message
        :key="dialog.key"
        :options="dialog"
        v-on:close="dialog.show = false"
      ></message>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { setTimeout } from 'timers'
import {
  getColorByStatus,
  getLabelByStatus,
  dateFormat,
} from '@/helpers/TransitHelper'
import loading from './../dialog/DialogLoading'
import importProduct from './../dialog/ImportProduct'
import deleting from './../dialog/DialogDeleteAll'
import message from './../dialog/Message'

export default {
  components: {
    loading,
    message,
    'upload-csv': importProduct,
    deleting,
  },
  data() {
    return {
      search: '',
      laboratory: '',
      loading: true,
      laboratories: [],
      pagination: {
        page: 1,
        rpp: this.$config.resultsPerPage,
        totalItems: 0,
        loading: true,
        pages: 0,
        search: {},
      },
      processing: false,
      csv: {
        show: null,
        data: null,
        key: 0,
      },
      dialog: {
        show: null,
        key: 0,
      },
      deleting: {
        show: null,
        key: 0,
      },
      complex: {
        headers: [
          {
            text: 'Producto',
            value: 'product.name',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Presentacion',
            value: 'fxFormula',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Reg. Sanitario',
            value: 'sanitaryReg',
            align: 'left',
            sortable: false,
          },
          {
            text: '# de Lote',
            value: 'batchNumber',
            align: 'left',
            sortable: false,
          },
          {
            text: ' Expiracion Reg. Sanitario',
            value: 'expirationDate',
            formatter: value => {
              return dateFormat(value)
            },
            align: 'left',
            sortable: false,
          },
          {
            text: 'Certificados',
            value: 'total_certificate',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Status',
            value: 'batchStatus',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Acciones',
            align: 'left',
            sortable: false,
          },
        ],
      },
    }
  },
  created() {
    this.$store.dispatch('laboratories/getAll', {}).then(response => {
      const data = response.items
      for (let index = 0; index < data.length; index += 1) {
        this.laboratories.push({
          text: data[index].name,
          value: data[index].id,
        })
      }
    })

    this.asyncPagination()
  },
  computed: {
    ...mapState({
      products: state => state.products.all,
    }),
  },
  methods: {
    helperPaginate(response) {
      this.pagination.totalItems = response.total
      this.pagination.pages =
        Math.ceil(this.pagination.totalItems / this.pagination.rpp) || 0
      this.loading = false
      this.pagination.loading = false
    },
    asyncPagination() {
      this.pagination.loading = true

      let filter = {
        rpp: this.pagination.rpp,
        page: this.pagination.page,
        ...this.pagination.search,
      }

      return new Promise(resolve => {
        this.$store.dispatch('products/getAll', filter).then(response => {
          this.helperPaginate(response)
          return resolve()
        })
      })
    },
    onSearch() {
      const params = { term: this.search, labId: this.laboratory }

      Object.keys(params).forEach(function(key) {
        if (params[key] == null || params[key] == '') delete params[key]
      })

      this.pagination.search = params
      this.pagination.page = 1
      this.asyncPagination()
    },
    dateFormat,
    getColorByStatus,
    getLabelByStatus,
    handleUploadCSV() {
      this.csv = {
        show: true,
        key: this.csv.key + 1,
      }
    },
    uploadReady(response) {
      this.loading = false
      this.processing = true
      this.$socket.emit('importProd', {
        fileImport: response.file,
        labId: response.labId,
      })
    },
    onDownload() {
      const filter = {
        ...this.pagination.search,
      }
      this.$socket.emit('exportProductBatches', filter)
    },
    deleteReady(total) {
      this.loading = false
      this.asyncPagination().then(() => {
        setTimeout(() => {
          this.loading = false
          this.dialog = {
            message: `(${total}) productos fueron eliminados del sistema`,
            color: 'success',
            show: true,
            key: this.dialog.key + 1,
          }
        }, 300)
      })
    },
    deleteProduct(batchNumber) {
      this.loading = true
      this.$store
        .dispatch('products/deleteById', { batchNumber: batchNumber })
        .then(response => {
          if (response.status == 401) {
            setTimeout(() => {
              this.loading = false
              this.dialog = {
                message:
                  'El producto no puede ser eliminado, se encuentra asociado dentro del sistema.',
                color: 'error',
                show: true,
                key: this.dialog.key + 1,
              }
            }, 100)
          } else {
            this.asyncPagination().then(() => {
              setTimeout(() => {
                this.loading = false
                this.dialog = {
                  message: 'El producto fue eliminado del sistema',
                  color: 'success',
                  show: true,
                  key: this.dialog.key + 1,
                }
              }, 100)
            })
          }
        })
    },
  },
  sockets: {
    importReady(response) {
      const errors = response.rowsError

      this.asyncPagination().then(() => {
        if (errors.length > 0) {
          setTimeout(() => {
            var filas = ''
            errors.forEach(val => {
              filas += `<div> La fila <span class="v-chip error white--text"><span class="v-chip__content">${val}</span></span> no puede ser procesada.</div>`
            })

            this.processing = false
            this.dialog = {
              message: `<div>Revise el archivo, <span class="v-chip warning white--text"><span class="v-chip__content">${
                errors.length
              }</span></span> errores fueron encontrados:<div> ${filas}`,
              color: 'error',
              show: true,
              key: this.dialog.key + 1,
            }
          }, 3000)
        } else {
          setTimeout(() => {
            this.processing = false
            this.loading = false
            this.dialog = {
              message: 'Los productos fueron importados correctamente',
              color: 'success',
              show: true,
              key: this.dialog.key + 1,
            }
          }, 3000)
        }
      })
    },
  },
}
</script>
